import { Icon24ActionTimeJumpLarge } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const HorizontalArrowsIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <g clipPath="url(#clip0_1226_877)">
        <path
          d="M12 3.75V20.25"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.10254 8.60278C4.32221 8.38311 4.67779 8.38311 4.89746 8.60278C5.11699 8.82246 5.11708 9.17808 4.89746 9.39771L2.85742 11.4377H9C9.31066 11.4377 9.5625 11.6896 9.5625 12.0002C9.56235 12.3108 9.31056 12.5627 9 12.5627H2.85742L4.89746 14.6028L4.96973 14.6907C5.1138 14.909 5.08964 15.2055 4.89746 15.3977C4.70526 15.5898 4.40871 15.6141 4.19043 15.47L4.10254 15.3977L1.10254 12.3977C1.05014 12.3453 1.00804 12.2828 0.979492 12.2131C0.973654 12.1989 0.970437 12.1838 0.96582 12.1692C0.948878 12.1157 0.937529 12.0594 0.9375 12.0002C0.9375 11.9448 0.947946 11.8917 0.962891 11.8411C0.968476 11.8221 0.97285 11.8028 0.980469 11.7844C1.00993 11.7135 1.05325 11.6497 1.10742 11.5969L4.10254 8.60278Z"
          fill="currentColor"
        />
        <path
          d="M19.1025 8.60278C19.3222 8.38311 19.6778 8.38311 19.8975 8.60278L22.8916 11.5969C22.9459 11.6497 22.989 11.7134 23.0186 11.7844C23.0262 11.8028 23.0305 11.8221 23.0361 11.8411C23.0511 11.8917 23.0625 11.9447 23.0625 12.0002C23.0625 12.0595 23.0502 12.1156 23.0332 12.1692C23.0286 12.1838 23.0254 12.1989 23.0195 12.2131C22.991 12.2826 22.9498 12.3454 22.8975 12.3977L19.8975 15.3977C19.6778 15.6172 19.3222 15.6172 19.1025 15.3977C18.8829 15.1781 18.883 14.8225 19.1025 14.6028L21.1426 12.5627H15C14.6894 12.5627 14.4377 12.3108 14.4375 12.0002C14.4375 11.6896 14.6893 11.4377 15 11.4377H21.1426L19.1025 9.39771C18.8829 9.17808 18.883 8.82246 19.1025 8.60278Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1226_877">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const HorizontalArrowsIcon = fplIcon(HorizontalArrowsIconLocal, Icon24ActionTimeJumpLarge);
